import { render, staticRenderFns } from "./recipe-instruction.vue?vue&type=template&id=c19b9ca4&"
import script from "./recipe-instruction.vue?vue&type=script&lang=js&"
export * from "./recipe-instruction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports